import { Form, Input } from "antd";

export default function Subtitle(props) {
  return (
    <Form.Item {...props} name="subtitle" className="w-full" label="Subtitle">
      <Input className="w-full" placeholder="Enter article subtitle" />
    </Form.Item>
  );
}
